/*
 * This file is part of Mitei Server.
 * Copyright (c) 2019 f0reachARR <f0reach@f0reach.me>
 *
 * Mitei Server is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * Mitei Server is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Mitei Server.  If not, see <http://www.gnu.org/licenses/>.
 */
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import * as React from 'react';
const messageSnackContext = React.createContext({
    isOpen: false,
    text: '',
    open: _msg => { },
    close: () => { },
});
const useStyles = makeStyles((theme) => createStyles({
    close: {
        padding: theme.spacing(0.5),
    },
}));
export const MessageSnackContextProvider = ({ children }) => {
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const contextValue = React.useMemo(() => ({
        isOpen: open,
        open: message => {
            setMessage(message);
            setOpen(true);
        },
        close: () => setOpen(false),
        text: message,
    }), [open, message]);
    return (React.createElement(messageSnackContext.Provider, { value: contextValue }, children));
};
export const useMessageSnack = () => {
    const contextValue = React.useContext(messageSnackContext);
    return contextValue.open;
};
export const MessageSnackView = () => {
    const contextValue = React.useContext(messageSnackContext);
    const styles = useStyles();
    const handleClose = () => {
        contextValue.close();
    };
    return (React.createElement(Snackbar, { anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, open: contextValue.isOpen, autoHideDuration: 6000, onClose: handleClose, message: contextValue.text, action: [
            React.createElement(IconButton, { key: 'close', color: 'inherit', className: styles.close, onClick: handleClose },
                React.createElement(Close, null)),
        ] }));
};
//# sourceMappingURL=index.js.map